<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'PAGES.DOMAINS.TITLE' | translate }}</glxy-page-title>
    @if ((isExpress$ | async) === false) {
      <glxy-page-actions>
        <button mat-flat-button color="primary" (click)="showAddDomainDialog()">
          <mat-icon>domain_verification</mat-icon>
          {{ 'PAGES.DOMAINS.BUTTONS.CONNECT_DOMAIN' | translate }}
        </button>
        <a class="toolbar-help-button" mat-icon-button target="_blank" href="https://docs.websitepro.hosting/">
          <mat-icon>help_outline</mat-icon>
        </a>
      </glxy-page-actions>
    }
  </glxy-page-toolbar>

  @if ((isExpress$ | async) === false) {
    <glxy-page-wrapper>
      <div class="page page-normal">
        <app-domain-instruction-card #domainInstructionCard></app-domain-instruction-card>
        @if (!areDomainsLoading) {
          <mat-table [dataSource]="dataSource" multiTemplateDataRows class="domain-list">
            <!-- Domain column -->
            <ng-container matColumnDef="domain">
              <th mat-header-cell *matHeaderCellDef class="domain-column header">
                {{ 'PAGES.DOMAINS.TABLE.HEADERS.DOMAINS' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="domain-column break-line">
                <div class="domain-name">
                  {{ element.domain }}
                </div>
                <mat-chip-listbox class="primary-chip">
                  @if (element.isPrimary) {
                    <mat-chip-option class="primary-chip-item" [disabled]="true">
                      {{ 'PAGES.DOMAINS.CHIPS.PRIMARY' | translate }}
                    </mat-chip-option>
                  }
                </mat-chip-listbox>
              </td>
            </ng-container>
            <!-- SSL cert column -->
            <ng-container matColumnDef="ssl_cert">
              <th mat-header-cell *matHeaderCellDef class="ssl-status-column header">
                {{ 'PAGES.DOMAINS.TABLE.HEADERS.SSL_CERTIFICATE' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="ssl-status-column break-line">
                @if (element.isAAAADetected) {
                  <mat-icon class="icon aaaa-detected">warning</mat-icon>
                } @else {
                  @if (element.hasSSLCert) {
                    <span>
                      <!-- Fix icon -->
                      <mat-icon class="icon connected">lock</mat-icon>
                    </span>
                  } @else {
                    <span>
                      <mat-icon class="icon pending">lock_open</mat-icon>
                    </span>
                  }
                }
                <span style="display: inline-flex; padding: 10px 0">
                  {{ element.translateSSLStatusKey | translate }}
                </span>
              </td>
            </ng-container>
            <!-- Status column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="status-column header">
                {{ 'PAGES.DOMAINS.TABLE.HEADERS.STATUS' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="status-column">
                @switch (element.status) {
                  @case (connected) {
                    <mat-icon class="icon connected">check_circle</mat-icon>
                  }
                  @case (pending) {
                    <mat-icon class="icon pending">cached</mat-icon>
                  }
                  @case (disconnected) {
                    <mat-icon class="icon disconnected">error_outline</mat-icon>
                  }
                }
                {{ element.translateStatusKey | translate }}
              </td>
            </ng-container>
            <!-- Actions column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="actions-column header"></th>
              <td mat-cell *matCellDef="let element" class="actions-column">
                @if (element.canSetPrimary) {
                  <a
                    mat-button
                    color="accent"
                    class="make-primary-button break-line"
                    (click)="setSkipExpanding(); showMakePrimaryDialog(element.domain)"
                  >
                    {{ 'PAGES.DOMAINS.ACTIONS.MAKE_PRIMARY' | translate }}
                  </a>
                }
                <div class="right">
                  @if (element.canDelete) {
                    <a
                      mat-button
                      class="remove-button"
                      (click)="setSkipExpanding(); showDeleteDomainDialog(element.domain)"
                    >
                      {{ 'PAGES.DOMAINS.ACTIONS.REMOVE' | translate }}
                    </a>
                  }
                  @if (element.status === disconnected) {
                    <mat-icon class="accordion" [class.accordion-up]="expandedElementMap.get(element.domain)">
                      keyboard_arrow_down
                    </mat-icon>
                  }
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="expandedEmpty">
              <td
                mat-cell
                *matCellDef="let element"
                [@detailExpand]="expandedElementMap.get(element.domain) ? '*' : 'void'"
              ></td>
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [colSpan]="element.isAAAADetected ? 1 : 4">
                <div
                  class="expand-text-row break-line"
                  [@detailExpand]="
                    expandedElementMap.get(element.domain) &&
                    (element.status === disconnected || element.isAAAADetected)
                      ? '*'
                      : 'void'
                  "
                >
                  @if (element.isAAAADetected) {
                    <div class="aaaa-message">
                      {{ 'PAGES.DOMAINS.SSL_STATUS.AAAA_WARNING' | translate }}
                    </div>
                  } @else {
                    <div class="instruction-container">
                      <div class="incorrect-dns">
                        <table class="responsive-table bordered">
                          <thead>
                            <tr>
                              <th class="col1">
                                {{ 'PAGES.DOMAINS.INCORRECT_DNS.RECORD' | translate }}
                              </th>
                              <th class="col2">
                                {{ 'PAGES.DOMAINS.INCORRECT_DNS.RECOMMENDED_VALUE' | translate }}
                              </th>
                              <th class="col3">
                                {{ 'PAGES.DOMAINS.INCORRECT_DNS.CURRENT_VALUE' | translate }}
                              </th>
                            </tr>
                          </thead>
                          <tbody class="dns-rows">
                            @for (instruction of uniqueInstructions; track instruction) {
                              @if (instruction.host === element.domain) {
                                <tr>
                                  <td class="col1">{{ instruction.recordType }}</td>
                                  <td class="col2">{{ instruction.targetValue }}</td>
                                  <td class="col3">
                                    <span [class.correct]="instruction.correct" class="current">
                                      {{ instruction.currentValue | translate }}
                                    </span>
                                  </td>
                                </tr>
                              }
                            }
                          </tbody>
                        </table>
                      </div>
                      <div class="instruction-text">
                        @if (element.shouldReconnect) {
                          <p>
                            {{ 'PAGES.DOMAINS.INCORRECT_DNS.INSTRUCTIONS' | translate }}
                          </p>
                          <p>
                            <a
                              href="https://websitepro.zendesk.com/hc/en-us/articles/27640427866391-Domain-Setup"
                              target="_blank"
                            >
                              {{ 'PAGES.DOMAINS.INCORRECT_DNS.LEARN_MORE' | translate }}
                              <mat-icon class="icon">open_in_new</mat-icon>
                            </a>
                          </p>
                        }
                      </div>
                    </div>
                  }
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              class="all-rows"
              *matRowDef="let element; columns: displayedColumns"
              [class.expanded-row]="expandedElementMap.get(element.domain)"
              [class.expandable-row]="element.status === disconnected || element.isAAAADetected"
              (click)="
                !getSkipExpanding()
                  ? expandedElementMap.set(element.domain, !expandedElementMap.get(element.domain))
                  : null
              "
            ></tr>
            <tr
              mat-row
              [class.hidden]="!element.isAAAADetected"
              *matRowDef="let element; columns: ['expandedEmpty', 'expandedDetail', 'expandedEmpty', 'expandedEmpty']"
              class="collapse"
            ></tr>
            <tr
              mat-row
              [class.hidden]="element.isAAAADetected || !element.status === disconnected"
              *matRowDef="let element; columns: ['expandedDetail']"
              class="collapse"
            ></tr>
          </mat-table>
        } @else {
          <mat-spinner [diameter]="60" [strokeWidth]="8" color="accent"></mat-spinner>
        }
        @if (accountId$ | async; as senderId) {
          <div class="email-domains">
            <email-domains
              [showEmpty]="false"
              [senderId]="{ senderType: senderType, senderID: senderId }"
              [domains]="allDomains$ | async"
              (deleteRequested)="handleDeleteEmailDomainRequested($event)"
            ></email-domains>
          </div>
        }
        <div>
          <app-advanced-settings></app-advanced-settings>
        </div>
      </div>
    </glxy-page-wrapper>
  }
</glxy-page>
